import React from 'react'

export default function BulletIcon () {
  return (
    <svg width='4' height='4' viewBox='0 0 4 4' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.22 3.264C1.344 3.264 0.612 2.544 0.612 1.656C0.612 0.768 1.344 0.0479997 2.22 0.0479997C3.096 0.0479997 3.828 0.768 3.828 1.656C3.828 2.544 3.096 3.264 2.22 3.264Z'
        fill='#191531'
      />
    </svg>
  )
}
